
var $ = window.$;
import util from '../utils/util';
import nmcConfig from '../config/config';
var console = window.console;

import tips from '../widget/tips'

import * as twofactor from '../lib/twofactor';

import cgiReporter from '../lib/cgiReporter';

var accountGuard = {
    /**
     * 错误代码，表示会话发生改变
     * 负数表示前端判断出来的错误，-8 没有使用
     */
    ERR_SESSION_HAS_CHANGED: -8,

    /**
     * 错误代码，表示开发商发生变化
     */
    ERR_OWNER_HAS_CHANGED: -9,

    /**
     * 记录页面加载后，当前用户的会话 key
     */
    landingSessionKey: util.getSessionKey(),

    /**
     * 记录页面检查登录后，当前用户对应的开发商 Uin
     */
    landingOwnerUin: null,

    /**
     * 判断 Cookie 里面的会话是否相对加载时已经发生了变化
     */
    isSessionChanged: function () {
        var currentSessionKey = util.getSessionKey();
        return currentSessionKey && currentSessionKey != accountGuard.landingSessionKey;
    },

    /**
     * 判断 Cookie 里面的 Owner 是否相对加载时已经发生了变化
     */
    isOwnerChanged: function () {
        var currentOwnerUin = util.getOwnerUin();
        if (!accountGuard.landingOwnerUin) {
            // 检查登录还没完成，不做判断
            return false;
        }
        return currentOwnerUin && currentOwnerUin != accountGuard.landingOwnerUin;
    },

    /**
     * 如果账户发生改变，3 秒后刷新页面
     */
    refreshTimeout: 3000,

    /**
     * 页面重新加载计时器 ID
     */
    refreshTimer: 0,

    /** 
     * 检查账号状况
     * @returns {number} 如果返回值为 0，则账号正常，否则账号异常，返回异常错误码
     */
    check: function () {
        // 会话发生改变时，不能进行请求，否则过时的 CSRFToken 会导致 Cookie 清除
        if (accountGuard.isSessionChanged()) {
            accountGuard.refreshTimer = accountGuard.refreshTimer || setTimeout(function () {
                window.location.reload();
            }, accountGuard.refreshTimeout);
            return accountGuard.ERR_SESSION_HAS_CHANGED;
        }
        // 开发商账号发生改变时，也需要刷新页面
        if (accountGuard.isOwnerChanged()) {
            accountGuard.refreshTimer = accountGuard.refreshTimer || setTimeout(function () {
                window.location.reload();
            }, accountGuard.refreshTimeout);
            return accountGuard.ERR_OWNER_HAS_CHANGED;
        }
        return 0;
    }
};

setInterval(function () {
    var accountStatus = accountGuard.check();
    if (accountStatus) {

        switch (accountStatus) {
            case accountGuard.ERR_SESSION_HAS_CHANGED:
                tips.error('会话已发生改变，页面即将刷新…');
                return;
            case accountGuard.ERR_OWNER_HAS_CHANGED:
                tips.error('开发商已切换，页面即将刷新…');
                return;
        }
    }
}, 3000);

/**
 * 网络请求
 * @class net
 * @static
 */
var net = {
    setLandingOwnerUin: function (ownerUin) {
        accountGuard.landingOwnerUin = ownerUin;
    },

    /**
     * 发起请求
     * @method send
     * @param  {Object} cgiConfig 配置
     * @param  {Object} opt 选参
     * @author evanyuan
     */
    send: function (cgiConfig, opt) {

        // 账号发生变化时，不能进行请求，否则过时的 CSRFToken 会导致 Cookie 清除
        var accountStatus = accountGuard.check();
        switch (accountStatus) {
            case accountGuard.ERR_SESSION_HAS_CHANGED:
                if (opt && opt.cb) {
                    opt.cb({ code: accountStatus, msg: '会话已发生改变，页面即将刷新…' });
                }
                return;
            case accountGuard.ERR_OWNER_HAS_CHANGED:
                if (opt && opt.cb) {
                    opt.cb({ code: accountStatus, msg: '开发商已切换，页面即将刷新…' })
                }
                return;
            default:
            // continue network request
        }

        var _self = net,
            _cgiConfig = cgiConfig,
            _data = opt.data || {},
            _url = "",
            _cb = null,
            _global = opt.global;

        if (!_cgiConfig) {
            _cgiConfig = {
                url: opt.url,
                method: opt.method
            };
        }

        if (_cgiConfig) {

            var _startTime = new Date();

            // 成功回调
            _cb = function (ret) {

                if (typeof (ret) === 'string') {
                    ret = JSON.parse(ret);
                }

                // 使用友好的提示消息
                if (ret && ret['uiMsg']) {
                    // 如果有内部错误消息，则输出log
                    if (console && console.warn && ret !== 0) {
                        var errorLog = [
                            '控制台 CGI 错误：' + _cgiConfig.url,
                            '  Code: ' + ret.code + ', Message: ' + ret.msg,
                            '  Detail: ' + JSON.stringify(ret.errObj, null, 4)
                        ];
                        console.warn(errorLog.join('\n'));
                    }
                    ret['msg'] = (ret['uiMsg'] || ret['msg']);
                    delete ret['uiMsg'];
                }

                //返回码上报
                var _endTime = new Date(),
                    _ignoreErrCode = nmcConfig.ignoreErrCode || [],
                    _code = _ignoreErrCode.indexOf(ret.code) < 0 ? ret.code : 0;

                reporter.retCode(_url, _code, _endTime - _startTime);
                cgiReporter.report({     //上报统一返回码系统
                    "url": _url,
                    "code": _code,
                    "time": _endTime - _startTime,
                    "opt": {
                        ext2: ret.mccode || 0,
                        ext3: ret.errObj && ret.errObj.send && ret.errObj.send["interface"] || "",
                        ext4: ret.errObj && ret.errObj.send && JSON.stringify(ret.errObj.send) || "",
                        ext5: ret.errObj && ret.errObj.back && JSON.stringify(ret.errObj.back) || "",
                    }
                });

                opt.cb && opt.cb(ret);
            };

            var urlParams = $.extend({
                t: new Date().getTime(),
                uin: util.getUin(),
                csrfCode: util.getACSRFToken()
            }, opt.additionalUrlParam || {});

            if (nmcConfig.additionalUrlParam) {
                $.extend(urlParams, nmcConfig.additionalUrlParam(_data, _cgiConfig.method || 'get'))
            }

            _url = _self._addParam(_cgiConfig.url, urlParams);

            if (_cgiConfig.method && _cgiConfig.method.toLowerCase() === "post") {
                return _self.post(_url, _data, _cb, _global);
            } else {
                return _self.get(_url, _data, _cb, _global);
            }

        }
    },

    /**
     * GET请求
     * @method get
     * @param  {String}   url    URL
     * @param  {Object}   data   参数
     * @param  {Function} cb     回调函数
     * @param  {Boolean}  global 是否触发全局 AJAX 事件
     * @author evanyuan
     */
    get: function (url, data, cb, global) {
        return this._ajax(url, data, 'GET', cb, global);
    },

    /**
     * POST请求
     * @method post
     * @param  {String}   url    URL
     * @param  {Object}   data   参数
     * @param  {Function} cb     回调函数
     * @param  {Boolean}  global 是否触发全局 AJAX 事件
     * @author evanyuan
     */
    post: function (url, data, cb, global) {
        return this._ajax(url, data, 'POST', cb, global);
    },

    _ajax: twofactor._netAjaxWrapper(function (url, data, method, cb, global, data_type) {
        (global == undefined) && (global = true);
        return $.ajax({
            type: method,
            url: url,
            data: data,
            dataType: data_type || 'json',
            global: global,
            success: function (data) {
                cb(data);
            },
            error: function (jqXHR) {
                if (jqXHR.status > 200) {
                    cb({ ret: jqXHR.status });
                }
            }
        });
    }),

    //用jsonp的方式来获取数据
    getJSON: function (url, data, cb, global) {
        return this._ajax(url, data, 'GET', cb, global, "jsonp");
    },

    _addParam: function (url, p) {
        var s = /\?/.test(url) ? '&' : '?';
        url += s + util.objectToParams(p);
        return url;
    }
};
export default net;

